export default {
  lazada: process.env.REACT_APP_LAZADA_ACCOUNT,
  jd: process.env.REACT_APP_JD_ACCOUNT,
  shopee: process.env.REACT_APP_SHOPEE_ACCOUNT,
  btv: process.env.REACT_APP_BTV_ACCOUNT,
  jdsm: process.env.REACT_APP_JDSM_ACCOUNT,
  scg: process.env.REACT_APP_SCG_ACCOUNT,
};
